import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import vuetify from './plugins/vuetify';
import {sync} from 'vuex-router-sync'
import permissionGuard from './router/guards/permissionsGuard'
import acl from "./plugins/acl";
import {useAuth} from "@/services/kcAuth";

sync(store, router)

permissionGuard(router, store)

Vue.config.productionTip = false

Vue.use(require('vue-chartist'))

Vue.use(acl, {store})

const {init} = useAuth();

init().then(() => {
    new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
    }).$mount('#app')
})